export type UIVersionInfoDto = {
	build_date: string;
	build_id: number;
	git_branch: string;
	git_hash: string;
	version: string;
};

export const defaultUIVersionInfoDto = (): UIVersionInfoDto => {
	return {
		build_date: '',
		build_id: 0,
		git_branch: '',
		git_hash: '',
		version: '',
	};
};
